import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-yoga-meditation',
  templateUrl: './yoga-meditation.component.html',
  styleUrls: ['./yoga-meditation.component.scss']
})
export class YogaMeditationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
